import React from 'react';
import { Route, Switch } from 'react-router-dom';

import ErrorMessage from 'src/views/components/ErrorMessage';

import CreateIssueModal from './CreateIssueModal';
import ExtensionConfig from './ExtensionConfig';
import OauthCallback from './OauthCallback';

const PagerDuty = () => (
  <Switch>
    <Route path="/integration-jira-ui/pagerduty/oauth/callback" component={OauthCallback}/>
    <Route path="/integration-jira-ui/pagerduty/create_issue_modal" component={CreateIssueModal}/>
    <Route path="/integration-jira-ui/pagerduty/extension_config" component={ExtensionConfig}/>
    <Route>
      <ErrorMessage error={['Unknown location for PagerDuty iframe']}/>
    </Route>
  </Switch>
);

export default PagerDuty;
